import React, { useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { AppDispatch, RootState } from "../../redux/store";
import { markNotificationAsRead } from "../../redux/notificationsSlice";

const NotificationMessage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { messageId } = useParams();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const userId = useSelector((s: RootState) => s.auth.user?.userId);
  const notifications = useSelector(
    (s: RootState) => s.notifications.notifications
  );

  const notification = notifications.find(
    (n) => n.notificationId === messageId
  );

  /* ✅ Mark as read automatically */
  useEffect(() => {
    if (userId && messageId) {
      dispatch(
        markNotificationAsRead({
          userId,
          notificationId: messageId,
        })
      );
    }
  }, [dispatch, userId, messageId]);

  if (!notification)
    return (
      <Box sx={{ color: "#fff", p: 5 }}>Notification not found</Box>
    );

  const formatDate = (ts?: number | null) => {
    if (!ts) return "";
    return new Date(ts).toLocaleString();
  };

  return (
    <Box
      sx={{
        height: "100vh",
        background:
          "linear-gradient(135deg, #0f172a 0%, #1e293b 40%, #0ea5e9 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      {/* 💎 Glass Card */}
      <Box
        sx={{
          width: "100%",
          maxWidth: 520,
          borderRadius: isMobile ? 0 : "28px",
          background: "rgba(255,255,255,0.08)",
          backdropFilter: "blur(25px)",
          WebkitBackdropFilter: "blur(25px)",
          boxShadow: "0 30px 80px rgba(0,0,0,0.4)",
          overflow: "hidden",
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "center",
            gap: 1,
            background: "rgba(255,255,255,0.05)",
          }}
        >
          <IconButton onClick={() => navigate(-1)} sx={{ color: "#fff" }}>
            <ArrowBackIcon />
          </IconButton>

          <NotificationsActiveIcon sx={{ color: "#FFD600" }} />

          <Typography color="#fff" fontWeight={700}>
            Notification
          </Typography>
        </Box>

        {/* BODY */}
        <Box sx={{ p: 4 }}>
          <Paper
            sx={{
              p: 3,
              borderRadius: "22px",
              background: "rgba(255,255,255,0.12)",
              backdropFilter: "blur(20px)",
            }}
          >
            {/* Title */}
            <Typography
              variant="h5"
              fontWeight={800}
              color="#fff"
              mb={2}
            >
              {notification.title}
            </Typography>

            {/* Message */}
            <Typography
              variant="body1"
              color="#e2e8f0"
              sx={{ lineHeight: 1.8 }}
            >
              {notification.message}
            </Typography>

            {/* Date */}
            <Typography
              variant="caption"
              color="#94a3b8"
              sx={{ mt: 3, display: "block" }}
            >
              {formatDate(notification.createdAt)}
            </Typography>
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default NotificationMessage;
